import { FunnelIcon } from "@heroicons/react/24/outline";
import ClientUtils from "../../utils/ClientUtils";
import { InternalIconProps } from "./types/SvgIconProps";
import withIconSize from "./hoc/withIconSize";

interface Props extends InternalIconProps {
  className?: string;
}

const AppFilterIcon = (props: Props) => {
  const { className, ...rest } = props;

  return (
    <FunnelIcon
      {...rest}
      className={ClientUtils.twClassNames("", props.className)}
    />
  );
};
export default withIconSize(AppFilterIcon);
